import { render, staticRenderFns } from "./ActionsTable.vue?vue&type=template&id=44721c44&scoped=true"
import script from "./ActionsTable.vue?vue&type=script&lang=ts&setup=true"
export * from "./ActionsTable.vue?vue&type=script&lang=ts&setup=true"
import style0 from "./ActionsTable.vue?vue&type=style&index=0&id=44721c44&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_babel-core@7.0.0-bridge.0_@babel+core@7.26.0__cache-loader@4.1.0_webpack@4_duly6tfyc62fvcli236pnhbyri/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44721c44",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {ImpactGoalActionInsight: require('/home/runner/work/assessment-service/assessment-service/frontend/components/impact-goal/ActionInsight.vue').default,ImpactGoalEvidenceCardListItem: require('/home/runner/work/assessment-service/assessment-service/frontend/components/impact-goal/EvidenceCardListItem.vue').default,IxPageLoading: require('/home/runner/work/assessment-service/assessment-service/frontend/components/ix/PageLoading.vue').default})
